import initC from "x/initC.js"

export const [hook, send] = initC(new BroadcastChannel(""))
